import { FC } from 'react';

interface IDashboardLogoProps {
	src: string;
}

const DashboardLogo: FC<IDashboardLogoProps> = ({ ...props }) => {
	return (
		<div className="absolute left-0 top-0 pl-2">
			<img src={props.src} className="fixed z-1 py-1 h-12 md:h-[58px] xl:h-[58px] w-auto" alt="MSI SEASCAPE" />
		</div>
	);
};

export default DashboardLogo;
